import { OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ItemsListRowComponent } from '@fi-app/components/items-list/list-row/list-row.component';
import { RollupContentComponent } from '@fi-shared/rollup/rollup-content.component';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { AppTextService } from '@fi-shared/app-text';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-document-template-confirm-delete-view-row',
    template: `
        <fi-rollup-content #rollupContent>
          <div class="confirm-delete-item-details-items">
            @for (item of getRowDataUsesItems(); track item) {
              <div class="uses-item">
                <a
                  href
                  [fiStateSref]="FiStateNames.Document.View"
                  [fiStateSrefParams]="{ Id: item.DocumentId }"
                  target="_blank"
                  (click)="itemClick(item, $event)"
                  class="BrandedColor item-link"
                  >{{ item.DocumentName }}</a
                  >
                </div>
              }
            </div>
          </fi-rollup-content>
        `,
    standalone: false,
})
export class DocumentTemplateConfirmDeleteViewRowComponent implements OnInit, OnDestroy {
    @ViewChild('rollupContent', { static: false }) rollupContent: RollupContentComponent;

    FiStateNames = FiStateNames;

    constructor(
        private appTextService: AppTextService,
        private fiDialogsService: FiDialogsService,
        private row: ItemsListRowComponent<any>,
    ) {}

    ngOnInit() {
        this._initEvents();
    }

    getRowDataUsesItems() {
        return this.row.data.UsesItems;
    }

    // note: not used ?
    itemClick(item, $event) {
        // TODO: Add check if user has rights to see the page
        // if (!item.HasViewAccess) {
        //     this.fiDialogsService.error({
        //         messageText: this.appTextService.get('mediaModule.delete_dialog_no_rights', {'{x}': this.appTextService.get('common.page')})
        //     });
        //     $event.preventDefault();
        //     $event.stopImmediatePropagation();
        //     $event.stopPropagation();
        // }
    }

    _initEvents() {
        this.row.events$.pipe(takeUntil(this.ngOnDestroy$)).subscribe((event) => {
            if (event.event === 'onShowUsesClick') {
                event.data ? this.rollupContent.openContent() : this.rollupContent.closeContent();
            }
        });
    }

    ngOnDestroy$ = new Subject<void>();

    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
